import { Injectable } from '@angular/core';
import { Router, RouterStateSnapshot, NavigationEnd, NavigationStart, ParamMap } from '@angular/router';
import { Location } from '@angular/common';
import { SecurityService, LoaderService } from 'src/app/services';
import moment from 'moment';
import { environment } from 'src/environments/environment';
import { PortalService } from './portal.service';
import _ from 'lodash';

@Injectable({ providedIn: 'root' })
export class RoutingService {

  private root: string = "";
  private ViewType: string = "";
  private ModuleId: string = "";
  private pageName: string = "";
  private featureName: string = "";
  private sponsorName: string = "";
  private portalName: string = "";
  private searchQuery: string = "";
  private isClientAdmin: boolean = false;
  private isMedPointAdmin: boolean = false;

  private paramMap!: ParamMap;
  constructor(
    private router: Router,
    private location: Location,
    private portalService: PortalService,
    private securityService: SecurityService,
    private loaderService: LoaderService
  ) {

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        //this.loaderService.showLoader();
      }
      if (event instanceof NavigationEnd) {
        this.updateState();
        this.parseUrl(this.router.routerState.snapshot);
        //this.loaderService.hideLoader();

        let currentUser = this.securityService.currentUserValue;
        if (currentUser) {
          const passwordChangedDate = moment(currentUser.PasswordChangedDate);
          const currentDate = moment.utc(new Date().toUTCString());
          const diffDays = currentDate.diff(passwordChangedDate, 'days');
          //console.log('Password expiry check : ', diffDays > environment.passwordExpirationDays, diffDays, environment.passwordExpirationDays);
          if (diffDays > environment.passwordExpirationDays) {
            this.loaderService.showLoader();
            window.location.href = environment.myAppUrl + "/Account/Manage/ChangePassword";
            return;
          }
        }
      }
    });
  }

  updateState() {
    this.securityService.manageUserSession(1);
    window.scrollTo(0, 0);
  }

  navigateBack() {
    this.location.back();
  }

  parseUrl(state: RouterStateSnapshot) {
    let url = "";

    const urlTree = this.router.parseUrl(state.url);

    this.paramMap = urlTree.queryParamMap;

    if (urlTree.queryParamMap.has('view')) {
      this.ViewType = <string>urlTree.queryParamMap.get('view');
    }
    if (urlTree.queryParamMap.has('mid')) {
      this.ModuleId = <string>urlTree.queryParamMap.get('mid');
    }
    if (urlTree.queryParamMap.has('q')) {
      this.searchQuery = <string>urlTree.queryParamMap.get('q');
    }
    if (urlTree.root.children['primary']) {
      const len = urlTree.root.children['primary'].segments.length;
      this.pageName = urlTree.root.children['primary'].segments.length > 1 ? urlTree.root.children['primary'].segments[len-2].path : "";
      this.featureName = urlTree.root.children['primary'].segments.length > 0 ? urlTree.root.children['primary'].segments[len - 1].path : "";
      this.root = urlTree.root.children['primary'].segments[0].path;
      this.isClientAdmin = _.filter(urlTree.root.children['primary'].segments, (item) => { return item.path.toLowerCase() == "clientadministration" }).length > 0;
      this.isMedPointAdmin = _.filter(urlTree.root.children['primary'].segments, (item) => { return item.path.toLowerCase() == "medpointadministration" }).length > 0;
    }
  }
  getFeatureName() {
    return this.featureName;
  }
  getPageName() {
    return this.pageName;
  }

  getDocumentViewType() {
    return this.ViewType == "" ? "category" : this.ViewType == "category" ? "category" : this.ViewType == "list" ? "list" : "category";
  }

  getSponsorName() {
    let portalInfo = this.portalService.portalConfiguation.value;
    return <string>portalInfo.SponsorName;
  }
  setSponsorName(sponsorName: string) {
    this.sponsorName = sponsorName;
  }

  getPortalName() {
    let portalInfo = this.portalService.portalConfiguation.value;
    return <string>portalInfo.PortalName;
  }

  setPortalName(portalName: string) {
    this.portalName = portalName;
  }

  getQueryStringValue(query: string) {
    return this.paramMap.has(query) ? <string>this.paramMap.get(query) : "";
  }

  IsClientAdmin() {
    return this.isClientAdmin;
  }

  IsMedPointAdmin() {
    return this.isMedPointAdmin;
  }
}
